import type { JSX } from 'react';
import type { Me } from '../auth/use-me';
import { useOverview } from '../overview/use-overview';
import { uptime } from '@/lib/format';
import { AgentButton, OnlinePill, ThemeToggle } from './header-controls';
import { Orb } from './orb';
import { navItems } from './routes';
import type { PageId } from './routes';
import { TopNav } from './top-nav';
import { UserMenu } from './user-menu';

/**
 * The 60px sticky, blurred bar: mark, page tabs, status, theme and the user
 * menu. On a phone the tabs and the status pill give way to the bottom tab bar
 * and an AGT button for Agent settings.
 */
export function AppHeader({ me, active }: { me: Me; active: PageId }): JSX.Element {
  const overview = useOverview().data;
  return (
    <header className="sticky top-0 z-20 border-b bg-[color-mix(in_oklch,var(--bg)_82%,transparent)] backdrop-blur-[14px]">
      <div className="mx-auto flex min-h-[60px] max-w-[1280px] flex-wrap items-center gap-x-4 px-6">
        <div className="order-1 flex flex-none items-center gap-3">
          <Orb size={30} />
          <div className="leading-[1.1]">
            <div className="text-sm font-semibold tracking-[.01em] whitespace-nowrap">
              Trucklane Pilot
            </div>
            <div className="text-mute font-mono text-[10.5px] tracking-[.06em] whitespace-nowrap">
              ADMIN · CONTROL PANEL
            </div>
          </div>
        </div>
        <TopNav
          items={navItems(me.role)}
          active={active}
          badges={{ health: overview?.sources.errors ?? 0 }}
        />
        <div className="order-3 ml-auto flex flex-none items-center gap-2.5">
          <OnlinePill
            uptime={overview === undefined ? undefined : uptime(overview.uptimeSeconds)}
          />
          <AgentButton active={active === 'agent'} />
          <ThemeToggle />
          <UserMenu me={me} />
        </div>
      </div>
    </header>
  );
}
